// extracted by mini-css-extract-plugin
export default {"root":"style_root__KecDb","hiddenInput":"style_hiddenInput__kzDGh","background":"style_background__KZmvL","content":"style_content__DYA8C","loader":"style_loader__9P2N8"};